export default (params) => ({
  trigger: {
    name: 'segment_navigation.navigate',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'general_navigation',
          'cross_links',
        ],
      },
    },
    event: {
      name: 'select_navigation',
    },
    nonInt: true,
  },
});
